import { useEffect, useRef } from "react";

const HOVERABLE = "a,button,[role='button'],input,select,textarea,label,[data-cursor]";

export const CustomCursor = () => {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const auraRef = useRef(null);

  useEffect(() => {
    if (!window.matchMedia("(pointer: fine)").matches) return undefined;
    document.documentElement.classList.add("has-custom-cursor");
    const dot = dotRef.current;
    const ring = ringRef.current;
    const aura = auraRef.current;
    let mx = -500, my = -500, rx = -500, ry = -500, ax = -500, ay = -500;
    let hovering = false, raf = 0;

    const onMove = (e) => {
      mx = e.clientX;
      my = e.clientY;
      const h = !!(e.target instanceof Element && e.target.closest(HOVERABLE));
      if (h !== hovering) {
        hovering = h;
        ring.classList.toggle("cursor-ring-active", h);
        dot.classList.toggle("cursor-dot-active", h);
        aura.classList.toggle("cursor-aura-active", h);
      }
    };

    const loop = () => {
      rx += (mx - rx) * 0.14;
      ry += (my - ry) * 0.14;
      ax += (mx - ax) * 0.06;
      ay += (my - ay) * 0.06;
      dot.style.transform = `translate3d(${mx}px, ${my}px, 0) translate(-50%, -50%)`;
      ring.style.transform = `translate3d(${rx}px, ${ry}px, 0) translate(-50%, -50%)`;
      aura.style.transform = `translate3d(${ax}px, ${ay}px, 0) translate(-50%, -50%)`;
      raf = requestAnimationFrame(loop);
    };

    window.addEventListener("mousemove", onMove, { passive: true });
    raf = requestAnimationFrame(loop);
    return () => {
      document.documentElement.classList.remove("has-custom-cursor");
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <>
      <div ref={auraRef} className="cursor-aura" aria-hidden="true" />
      <div ref={dotRef} className="custom-cursor-dot" aria-hidden="true" />
      <div ref={ringRef} className="custom-cursor-ring" aria-hidden="true" />
    </>
  );
};
